// Mock data for Emerald Corporates clone

export const stockTickerData = [
  { symbol: 'AAPL', price: '$316.22', change: '0.90%', delta: '2.83', up: true },
  { symbol: 'TSLA', price: '$406.55', change: '3.17%', delta: '12.49', up: true },
  { symbol: 'MSFT', price: '$384.36', change: '0.27%', delta: '1.02', up: true },
  { symbol: 'NVDA', price: '$202.78', change: '-0.66%', delta: '-1.34', up: false },
  { symbol: 'GOOGL', price: '$189.14', change: '1.42%', delta: '2.65', up: true },
  { symbol: 'AMZN', price: '$228.90', change: '0.88%', delta: '2.00', up: true },
  { symbol: 'META', price: '$612.45', change: '-0.34%', delta: '-2.11', up: false },
];

export const navItems = [
  { label: 'Home', to: '/' },
  {
    label: 'About Us',
    to: '/about',
    submenu: [
      { label: 'Our Story', to: '/about' },
      { label: 'Leadership', to: '/leadership' },
    ],
  },
  {
    label: 'Verticals',
    to: '/verticals',
    submenu: [
      { label: 'Bullion & Precious Metals', to: '/verticals/bullion-precious-metals' },
      { label: 'Corporate Finance', to: '/verticals/corporate-finance' },
      { label: 'Capital Markets & Investment Banking', to: '/verticals/capital-markets' },
      { label: 'Technology & IT Infrastructure', to: '/verticals/technology-it-infrastructure' },
      { label: 'Cyber Security & Cryptology', to: '/verticals/cyber-security' },
      { label: 'Airport & Aviation Systems', to: '/verticals/airport-aviation' },
      { label: 'Oil, Gas & Energy', to: '/verticals/oil-gas-energy' },
      { label: 'Agriculture & Agro Trading', to: '/verticals/agriculture-agro' },
      { label: 'Mining & Resources', to: '/verticals/mining-resources' },
      { label: 'Hospitality & Real Estate', to: '/verticals/hospitality-real-estate' },
      { label: 'Digital Marketing & Media', to: '/verticals/digital-marketing-media' },
      { label: 'Digital Assets', to: '/verticals/digital-assets' },
    ],
  },
  { label: 'CSR', to: '/csr' },
  {
    label: 'Newsroom',
    to: '/newsroom',
    submenu: [
      { label: 'Emerald News', to: '/newsroom' },
      { label: 'Market Headlines', to: '/news' },
      { label: 'Galleries', to: '/galleries' },
    ],
  },
  { label: 'Blog', to: '/blog' },
  { label: 'Career', to: '/career' },
  { label: 'Contact', to: '/contact' },
];

export const heroContent = {
  eyebrow: 'The World of',
  headline: 'Emerald',
  description:
    'Emerald Corporates is a global conglomerate with international alliances and eleven interconnected verticals — spanning bullion, corporate finance, capital markets, technology, energy, mining, agriculture, hospitality and beyond.',
  cta: 'Explore Verticals',
  image:
    'https://images.unsplash.com/photo-1590018363780-f0d10b4fc043?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxlbWVyYWxkJTIwZ2Vtc3RvbmV8ZW58MHx8fGdyZWVufDE3ODM2MzM4MzR8MA&ixlib=rb-4.1.0&q=85',
};

export const latestNews = {
  date: 'Jul 9, 2026',
  title: 'Is one daily peg good for health? Study debunks common alcohol myth',
  excerpt:
    'A study published in the American Heart Association journal Hypertension has found that even one alcoholic drink a day may gradually increase blood pressure. Researchers say the risk rises with higher alcohol intake.',
  image:
    'https://images.unsplash.com/photo-1470337458703-46ad1756a187?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHx3aGlza2V5JTIwZ2xhc3N8ZW58MHx8fHwxNzgzNjMzODM0fDA&ixlib=rb-4.1.0&q=85',
};

export const stats = [
  { value: '7+', label: 'Countries' },
  { value: '11', label: 'Verticals' },
  { value: '3', label: 'Continents' },
  { value: '50+', label: 'Partners' },
];

export const services = [
  {
    title: 'Bullion Trading',
    description:
      'Trusted global partner for physical gold, silver and precious metals trading with secured vaulting and logistics.',
    image:
      'https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxnb2xkJTIwYnVsbGlvbnxlbnwwfHx8fDE3ODM2MzM4MzV8MA&ixlib=rb-4.1.0&q=85',
    to: '/services/bullion-trading',
  },
  {
    title: 'Corporate Finance',
    description:
      'Strategic advisory across mergers, acquisitions, debt syndication and structured funding solutions.',
    image:
      'https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODM2MzM4MzR8MA&ixlib=rb-4.1.0&q=85',
    to: '/services/corporate-finance',
  },
  {
    title: 'Primary & Secondary Market Services',
    description:
      'Venture capital, SBICs, investment banking and full-spectrum capital market execution.',
    image:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdG9jayUyMHRyYWRpbmd8ZW58MHx8fHwxNzgzNjMzODM1fDA&ixlib=rb-4.1.0&q=85',
    to: '/services/market-services',
  },
];

export const whoWeAreImage =
  'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1400&q=80';

export const footerLinks = {
  company: [
    { label: 'About Us', to: '/about' },
    { label: 'Contact', to: '/contact' },
    { label: 'Newsroom', to: '/newsroom' },
    { label: 'Market Headlines', to: '/news' },
    { label: 'Careers', to: '/career' },
  ],
  services: [
    { label: 'Bullion & Precious Metals', to: '/verticals/bullion-precious-metals' },
    { label: 'Corporate Finance', to: '/verticals/corporate-finance' },
    { label: 'Capital Markets & Investment Banking', to: '/verticals/capital-markets' },
    { label: 'Technology & IT Infrastructure', to: '/verticals/technology-it-infrastructure' },
    { label: 'Cyber Security & Cryptology', to: '/verticals/cyber-security' },
    { label: 'Airport & Aviation Systems', to: '/verticals/airport-aviation' },
    { label: 'Oil, Gas & Energy', to: '/verticals/oil-gas-energy' },
    { label: 'Agriculture & Agro Trading', to: '/verticals/agriculture-agro' },
    { label: 'Mining & Resources', to: '/verticals/mining-resources' },
    { label: 'Hospitality & Real Estate', to: '/verticals/hospitality-real-estate' },
    { label: 'Digital Marketing & Media', to: '/verticals/digital-marketing-media' },
    { label: 'Digital Assets', to: '/verticals/digital-assets' },
  ],
};
